import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'hdw-about-organ-transport',
  templateUrl: './about-organ-transport.component.html',
  styleUrls: ['./about-organ-transport.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AboutOrganTransportComponent {}
